import { Button } from "components/Button/Button";
import { useDispatch } from "react-redux";
import { addTodo } from "redux/todos/todosSlice";
import css from "./TaskForm.module.css";

export const TaskForm = () => {
  const dispatch = useDispatch();
  const handleSubmit = event => {
    event.preventDefault();
    const form = event.target.elements.text.value;
    dispatch(addTodo(form));
    event.target.reset();
  };

  return (
    <form className={css.form} onSubmit={handleSubmit}>
      <input
        className={css.field}
        type="text"
        name="text"
        placeholder="Enter task text..."
      />
      <Button type="submit">Add task</Button>
    </form>
  );
};
